"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultTransformRegistry_1 = require("./DefaultTransformRegistry");
var RowShiftCalculation_1 = require("./calculations/RowShiftCalculation");
var TimeShiftCalculation_1 = require("./calculations/TimeShiftCalculation");
var DataPointsQuery;
(function (DataPointsQuery) {
    DataPointsQuery.build = function (registry) {
        if (registry === void 0) { registry = DefaultTransformRegistry_1.DefaultTransformRegistry; }
        var calcNames = Object.keys(registry);
        var defaults = {};
        if (registry[TimeShiftCalculation_1.TimeShiftType] === TimeShiftCalculation_1.timeShiftTransformCreator) {
            defaults[TimeShiftCalculation_1.TimeShiftType] = 2;
        }
        if (registry[RowShiftCalculation_1.RowShiftType] === RowShiftCalculation_1.rowShiftTransformCreator) {
            defaults[RowShiftCalculation_1.RowShiftType] = 2;
        }
        var calculations = __assign(__assign({}, calcNames.reduce(function (calcs, calcName) {
            calcs[calcName] = 1;
            return calcs;
        }, {})), defaults);
        return {
            v1: {
                calculations: calculations,
            },
        };
    };
})(DataPointsQuery = exports.DataPointsQuery || (exports.DataPointsQuery = {}));
//# sourceMappingURL=DataPointsQuery.js.map